const prvaDiagnozaIzbiraPaketa = {
    paket: {
        name: 'paket',
        type: 'tns:PaketPrvaDiagnoza',
        formType: 'radio-multiple',
        value: undefined,
        required: true,
        text: {
            sl: 'Izberite paket',
        },
        options: [
            { 
                name: 'BrezNapotnice',
                value: 'BrezNapotnice',
                text: {
                    sl: 'PRVA Diagnoza brez napotnice + zdravila',
                },
            },
            { 
                name: 'BrezNapotnice-Rehabilitacije-OperativniPosegiZV10k',
                value: 'BrezNapotnice+Rehabilitacije+OperativniPosegiZV10k',
                text: {
                    sl: 'PRVA Diagnoza brez napotnice + zdravila + rehabilitacija in operativni posegi 10.000 EUR',
                },
            },
            { 
                name: 'BrezNapotnice-Rehabilitacije-OperativniPosegiZV40k',
                formType: 'radio-option',
                value: 'BrezNapotnice+Rehabilitacije+OperativniPosegiZV40k',
                text: {
                    sl: 'PRVA Diagnoza brez napotnice + zdravila + rehabilitacija in operativni posegi 40.000 EUR',
                },
            },  
        ],
    },
    q1: {
        name: 'q1',
        type: 'tns:PrvaDiagnozaVprasalnikType',
        formType: 'radio-DA-NE-with-extra-data-if-DA',
        value: {
            NE: null,
            DA: null,
        },
        required: true,
        error: null,
        text: {
            sl: 'Ali se vam je v zadnjih petih (5) letih pojavila bolezen, poškodba s posledicami ali bolezensko stanje, za katero ste se zavedali simtomov, ste se zdravili oz. nameravali zdraviti, ne glede na to ali vam je bilo navedeno stanje diagnosticirano oz. zdravljeno?',
        },
        extraDataText: 'Če ste odgovorili DA, prosimo, podrobno opišite težavo, navedite diagnozo in točno opredelite prizadeti del telesa (lokacijo in stran):',
        extraDataFileInputText: 'Priložite morebitne izvide v povezavi z zgornjim vprašanjem',
    },
    q2: {
        name: 'q2',
        type: 'tns:PrvaDiagnozaVprasalnikType',
        formType: 'radio-DA-NE-with-extra-data-if-DA',
        value: {
            NE: null,
            DA: null,
        },
        required: true,
        error: null,
        text: {
            sl: 'Ali ste bili v preteklem letu zaradi kronične bolezni, kroničnega stanja ali ponavljajoče se poškodbe nesposobni za delo dlje kot štirinajst (14) dni?',
        },
        extraDataText: 'Če ste odgovorili DA, prosimo, podrobno opišite težavo, navedite diagnozo in točno opredelite prizadeti del telesa (lokacijo in stran):',
        extraDataFileInputText: 'Priložite morebitne izvide v povezavi z zgornjim vprašanjem',
    },
    q3: {
        name: 'q3',
        type: 'tns:PrvaDiagnozaVprasalnikType',
        formType: 'radio-DA-NE-with-extra-data-if-DA',
        value: {
            NE: null,
            DA: null,
        },
        required: true,
        error: null,
        text: {
            sl: 'Ali imate napotnico za specialistično zdravljenje, diagnostični pregled, operativni poseg ali za katero koli terapijo s področja fizioterapije, delovne ali protibolečinske terapije s terminom obravnave v prihodnjih dveh (2) letih?',
        },
        extraDataText: 'Če ste odgovorili DA, prosimo, podrobno opišite težavo, navedite diagnozo in točno opredelite prizadeti del telesa (lokacijo in stran):',
        extraDataFileInputText: 'Priložite morebitne izvide v povezavi z zgornjim vprašanjem',
    },
};

module.exports = { prvaDiagnozaIzbiraPaketa };